import Vue from "vue";
import PasswordReissue from "./index.vue";
import {
  ContainerData,
  ContainerMethods,
  ContainerComputed,
  ContainerProps
} from "./types";

export default Vue.extend<
  ContainerData,
  ContainerMethods,
  ContainerComputed,
  ContainerProps
>({
  data() {
    return {
      isLoading: false,
      errors: [],
      ga: {
        error: []
      }
    };
  },
  computed: {
    auth() {
      return this.$store.state.domains.user.passwordReissue;
    }
  },
  methods: {
    async handleSubmit() {
      this.isLoading = true;
      this.ga.error.splice(0);
      await this.$store
        .dispatch("domains/user/passwordReissue", {
          email: this.auth.email
        })
        .then(
          () => {
            this.$router.push({ name: "PasswordWait" }).catch(err => err);
            this.errors = [];
          },
          error => {
            if (error.response.data) {
              this.errors = error.response.data.errors;
              this.errors.forEach(error => {
                this.ga.error.push(error.name);
              });
            } else {
              // NOTE: response.dataの無いエラー
              this.errors = [
                {
                  name: "unknown",
                  messages: ["エラーが発生しました"]
                }
              ];
              this.ga.error.push(this.errors[0].name);
            }
          }
        );
      this.isLoading = false;
    }
  },
  render(createElement) {
    return createElement(PasswordReissue, {
      props: {
        isLoading: this.isLoading,
        errors: this.errors
      },
      on: {
        submit: this.handleSubmit
      }
    });
  }
});
